// Blog posts. To add a post, append an entry here; /blog and /blog/:slug pick it up.
// body blocks: { t: "p" | "h2" | "h3", x: text }. Inline links use [text](/path) syntax.
export const blogs = [
  {
    slug: "how-much-pizza-to-order-for-a-party-la-porte-tx",
    title: "How Much Pizza Should You Order for a Party in La Porte, TX?",
    metaTitle: "How Much Pizza to Order for a Party in La Porte, TX | Village Pizza & Seafood",
    description:
      "Planning a party in La Porte, TX? Learn how many slices per guest to plan for, how to choose toppings and sides, and how to confirm a large pizza order.",
    date: "2026-10-26",
    readMins: 5,
    category: "Party Planning",
    image: "/images/menu/pizza-10-topping-special.jpg",
    imageAlt: "Village 10-Topping Special pizza",
    body: [
      {
        t: "p",
        x: "Planning food for a gathering should feel easier than organizing the guest list. Whether you are hosting a birthday, watching football with friends, or feeding everyone before Halloween activities, the question usually comes first: how much pizza should you order?",
      },
      {
        t: "p",
        x: "For a starting estimate, allow two to three slices per adult and one to two per younger child, then adjust for appetite, pizza size, and other dishes. These are planning estimates, not guaranteed portions. At Village Pizza & Seafood in La Porte, the menu lists small 10 inch and large 15 inch pizzas. Confirm the slice count when ordering before converting portions into pizzas.",
      },

      { t: "h2", x: "Start With Your Guest List" },
      {
        t: "p",
        x: "Count the people who will actually eat, rather than everyone invited. Separate adults, younger children, and teenagers because their appetites can differ considerably. A teenage sports team may need more food than a gathering of adults enjoying pizza alongside pasta and salad.",
      },
      {
        t: "p",
        x: "Consider when you are serving the meal. Guests arriving hungry at dinner will probably eat more than people having an afternoon snack. Longer gatherings can also encourage second helpings.",
      },
      {
        t: "p",
        x: "Ask about dietary needs early. Vegetarian preferences, food allergies, and ingredient restrictions affect topping choices and preparation questions. Contact the restaurant directly about ingredients and handling rather than assuming any pizza is suitable.",
      },

      { t: "h2", x: "Calculate Portions Before Counting Pizzas" },
      {
        t: "p",
        x: "Use a simple formula: estimated guests multiplied by expected slices per guest, divided by the confirmed slices per pizza. Round the answer upward.",
      },
      {
        t: "p",
        x: "For example, ten adults eating three slices each would need thirty slices. If the restaurant confirms eight slices per large pizza, thirty divided by eight equals 3.75, suggesting four pizzas.",
      },
      {
        t: "p",
        x: "Using those same assumptions, twenty adults would need about eight pizzas, while thirty adults would need about twelve. However, eight slices is only an example; Village Pizza's actual cutting pattern must be confirmed.",
      },
      {
        t: "p",
        x: "Slice count alone does not describe the amount of food. A slice from a smaller pizza contains less pizza than a comparable slice from a larger one. Ask about both diameter and cutting style, especially when comparing options for children and adults.",
      },

      { t: "h2", x: "Choose Toppings That Suit Your Group" },
      {
        t: "p",
        x: "A balanced selection makes ordering simpler. Include a familiar option, a meat option, and a vegetable option when those choices match your guests.",
      },
      {
        t: "p",
        x: "The [Village Pizza menu](/menu?category=pizza) includes pepperoni, Meat Combo, Veggie Combo, Hawaiian, and other specialty pizzas. Choose from the current menu instead of assuming a topping or special request is available.",
      },
      {
        t: "p",
        x: "For larger groups, collect broad preferences rather than asking everyone to design an individual pizza. One person might prefer vegetables while another wants pepperoni, but a few thoughtfully selected options can cover most preferences.",
      },
      {
        t: "p",
        x: "Keep vegetarian selections clearly identified when serving. For allergies, separate serving utensils alone may not address preparation risks; discuss the specific concern with the restaurant before placing your order.",
      },

      { t: "h2", x: "Add Sides With a Purpose" },
      {
        t: "p",
        x: "Sides can make a pizza meal more varied, but they should support your portion plan rather than complicate it. If guests will also eat substantial servings of pasta or subs, start toward the lower end of your pizza estimate.",
      },
      {
        t: "p",
        x: "Village Pizza's menu lists salads, garlic bread, family pasta dishes, and seafood dinners. Its Party Helper section also includes subs, salad, pasta, and wings, with a general indication of approximately ten servings.",
      },
      {
        t: "p",
        x: "Review each item's description carefully. A tray described as serving a group does not mean it will satisfy every guest as their entire meal. Appetite, serving size, and other food still matter.",
      },
      {
        t: "p",
        x: "Browse the [family meals and party options](/menu?category=partyHelper) to build an order around your gathering. Confirm portions and availability directly, particularly if you need multiple trays.",
      },

      { t: "h2", x: "Plan Around Your Occasion" },
      {
        t: "p",
        x: "For a football watch party, decide whether food will arrive before kickoff or during a break. Serving everything together helps guests find their preferred toppings without interrupting the game repeatedly.",
      },
      {
        t: "p",
        x: "For Halloween, offer dinner before children leave for activities, or choose a clear serving time after everyone returns. Keep pizza planning separate from any assumption that the restaurant offers seasonal discounts or themed products.",
      },
      {
        t: "p",
        x: "Birthday gatherings often include cake, snacks, and drinks. Those extras may reduce how much pizza some guests eat, but they should not replace enough food for guests expecting dinner.",
      },
      {
        t: "p",
        x: "For workplace lunches, consider employees' different break times. Coordinate serving and collection so everyone has a reasonable opportunity to eat.",
      },

      { t: "h2", x: "Confirm Your Order Before Party Day" },
      {
        t: "p",
        x: "Large orders deserve a direct conversation with the restaurant. Ask about preparation time, pickup arrangements, special requests, and whether your preferred time can be accommodated.",
      },
      {
        t: "p",
        x: "Have your guest count, pizza sizes, topping selections, and sides ready before calling. Repeat the details back and check the final total. Review current prices rather than relying on an older screenshot or a previous order.",
      },
      { t: "p", x: "Keep a written copy of the order handy for a final pickup check." },
      {
        t: "p",
        x: "The [Village Pizza & Seafood La Porte page](/la-porte) lists the location at 1128 S Broadway St and the phone number as (281) 470-7007. Use the restaurant's current ordering information to confirm arrangements.",
      },

      { t: "h2", x: "Common Party Ordering Questions" },
      { t: "h3", x: "How many pizzas should I order for ten people?" },
      {
        t: "p",
        x: "Begin with twenty to thirty slices for ten adults, then divide by the confirmed slice count. Adjust for children, appetite, pizza diameter, and substantial sides.",
      },
      { t: "h3", x: "Should I order extra pizza?" },
      {
        t: "p",
        x: "A modest buffer can help when attendance or appetite is uncertain. Avoid automatically doubling the order; confirm guests and calculate realistic portions first.",
      },
      { t: "h3", x: "Can I combine pizza with seafood or pasta?" },
      {
        t: "p",
        x: "Yes, the menu includes those categories. Choose quantities that reflect how your guests will divide their meal, and confirm serving information with the restaurant.",
      },

      { t: "h2", x: "Make Your La Porte Gathering Easier" },
      {
        t: "p",
        x: "The best party order starts with a clear headcount, realistic portions, and options your guests enjoy. Check the menu, confirm pizza cutting and group order details, and arrange a practical serving time. With those decisions settled, you can spend more time enjoying your guests and less time wondering whether dinner will stretch far enough.",
      },
    ],
    // CTA at the end of the post
    locationId: "la-porte",
  },
];

export const getBlogBySlug = (slug) => blogs.find((b) => b.slug === slug);

export const formatBlogDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
